define('presentation/common/callDetails/viewModels/callDetailsViewModel',['common/collections/collectionSorter',
        'common/storage/commonState',
        'constants/receptionistMessageConstants'
    ],
    function () {
        return function () {
            const self = this;

            const SorterConstructor = require('common/collections/collectionSorter');
            const sorter = new SorterConstructor();

            const _commonState = require('common/storage/commonState');
            const _receptionistMessageConstants = require('constants/receptionistMessageConstants');

            let _settings = null;

            self.isCompositionComplete = ko.observable(false);
            self.callDetails = ko.observable(null);
            self.showCallMedia = ko.observable(false);
            self.showFormSubmission = ko.observable(false);
            self.isCollapsible = ko.observable(true);

            self.callId = ko.pureComputed(() => {
                return self.callDetails() !== null ? self.callDetails().callId : null;
            });

            self.chatId = ko.pureComputed(() => {
                return self.callDetails() !== null && self.callDetails().webChat !== null ? self.callDetails().webChat.webChatId : null;
            });

            self.voicemail = ko.pureComputed(() => {
                return self.callDetails() !== null && self.callDetails().voicemail ? self.callDetails().voicemail : null;
            });

            self.recording = ko.pureComputed(() => {
                return self.callDetails() !== null && self.callDetails().recording ? self.callDetails().recording : null;
            });

            self.receptionistMessage = ko.pureComputed(() => {
                return self.callDetails() !== null && self.callDetails().receptionistMessage ? self.callDetails().receptionistMessage : null;
            });

            self.webChat = ko.pureComputed(() => {
                return self.callDetails() !== null && self.callDetails().webChat;
            });

            self.formResponses = ko.pureComputed(() => {
                return self.receptionistMessage() ? self.receptionistMessage().formResponses : [];
            });

            self.showMoreTranscript = ko.observable(false);

            self.showViewMoreTranscript = ko.pureComputed(() => {
                if (self.receptionistMessage() && self.receptionistMessage().webChatTranscript.length > 5 && !self.showMoreTranscript()) {
                    return true;
                }
                if (self.webChat() && self.webChat().webChatTranscript.length > 5 && !self.showMoreTranscript()) {
                    return true;
                }
                return false;
            });

            self.transcript = ko.pureComputed(() => {
                if (self.receptionistMessage()) {
                    if (self.receptionistMessage().webChatTranscript.length < 6 || self.showMoreTranscript()) {
                        return self.receptionistMessage().webChatTranscript;
                    }
                    return self.receptionistMessage().webChatTranscript.slice(0, 5);
                }
                if (self.webChat()) {
                    if (self.webChat().webChatTranscript.length < 6 || self.showMoreTranscript()) {
                        return self.webChat().webChatTranscript;
                    }
                    return self.webChat().webChatTranscript.slice(0, 5);
                }
                return [];
            });

            self.onShowMoreTranscript = () => {
                self.showMoreTranscript(true);
            };

            self.mapUrl = ko.pureComputed(() => {
                return self.callDetails() !== null ? self.callDetails().mapUrl : null;
            });

            self.showCallId = ko.pureComputed(() => {
                return self.callId() !== null;
            });

            self.showChatId = ko.pureComputed(() => {
                return self.chatId() !== null;
            });

            self.showMap = ko.pureComputed(() => {
                return self.mapUrl() !== null;
            });

            self.showUserSubmittedInfo = ko.pureComputed(() => {
                if (self.receptionistMessage()) {
                    return self.receptionistMessage().interactionType === _receptionistMessageConstants.interactionType.chat.id;
                }
                if (self.webChat()) {
                    return true;
                }
                return false;
            });

            self.userSubmittedName = ko.pureComputed(() => {
                const message = self.receptionistMessage() ? self.receptionistMessage() : self.webChat();

                if (!message) {
                    return '';
                }

                switch (message.junkStatus) {
                    case _receptionistMessageConstants.junkStatus.abandoned.id:
                        return _receptionistMessageConstants.junkStatus.abandoned.name;
                    case _receptionistMessageConstants.junkStatus.hangup.id:
                        return (_receptionistMessageConstants.junkStatus.hangup.name);
                    case _receptionistMessageConstants.junkStatus.spam.id:
                        return _receptionistMessageConstants.junkStatus.spam.name;
                    case _receptionistMessageConstants.junkStatus.externalWebsite.id:
                        return _receptionistMessageConstants.junkStatus.externalWebsite.name;
                    default:
                        return message.participantName;
                }
            });

            self.userSubmittedEmail = ko.pureComputed(() => {
                if (self.receptionistMessage()) {
                    return self.receptionistMessage().participantEmailAddress;
                }
                if (self.webChat()) {
                    return self.webChat().participantEmailAddress;
                }
                return '';
            });

            self.userSubmittedDomain = ko.pureComputed(() => {
                if (self.receptionistMessage()) {
                    return self.receptionistMessage().domain;
                }
                if (self.webChat()) {
                    return self.webChat().domain;
                }
                return '';
            });

            self.showForm = ko.pureComputed(() => {
                return self.showFormSubmission() && self.receptionistMessage() && self.receptionistMessage().receptionistMessageId;
            });

            self.hasFormResponses = ko.pureComputed(() => {
                return self.formResponses() !== null && self.formResponses().length > 0;
            });

            self.showTranscription = ko.pureComputed(() => {
                if (self.receptionistMessage()) {
                    return self.receptionistMessage().interactionType === _receptionistMessageConstants.interactionType.chat.id && self.receptionistMessage().webChatTranscript.length > 0;
                }
                if (self.webChat()) {
                    return self.webChat().webChatTranscript.length > 0;
                }
                return false;
            });

            self.hasTranscriptMessages = ko.pureComputed(() => {
                return self.transcript() !== null && self.transcript().length > 0;
            });

            self.showVoicemail = ko.pureComputed(() => {
                if (!self.showCallMedia()) {
                    return false;
                }

                return self.voicemail() && self.voicemail().hasMessage();
            });

            self.isVoicemailDisabled = ko.pureComputed(() => {
                return !self.voicemail().hasSubscription() || self.voicemail().isDeleted();
            });

            self.showRecording = ko.pureComputed(() => {
                if (!self.showCallMedia()) {
                    return false;
                }

                return self.recording() && self.recording().hasMessage();
            });

            self.isRecordingDisabled = ko.pureComputed(() => {
                return !self.recording().hasSubscription() || self.recording().isDeleted();
            });

            self.subscriberIds = ko.pureComputed(() => {
                if (self.showFormSubmission() && self.receptionistMessage()) {
                    return self.receptionistMessage().subscriberIds() ? self.receptionistMessage().subscriberIds() : [];
                }
                if (self.voicemail() && self.voicemail().status() === "success") {
                    return self.voicemail().subscriberIds() ? self.voicemail().subscriberIds() : [];
                }
                if (self.recording() && self.recording().status() === "success") {
                    return self.recording().subscriberIds() ? self.recording().subscriberIds() : [];
                }

                return [];
            });

            self.hasRecipients = ko.pureComputed(() => self.receptionistMessage() && self.receptionistMessage().recipients.length > 0);
            self.recipients = ko.pureComputed(() => {
                return self.hasRecipients() ? self.receptionistMessage().recipients : [];
            });

            self.hasSubscribers = ko.pureComputed(() => self.subscriberIds().length > 0);
            self.subscribers = ko.pureComputed(() => {
                let subscribers = self.subscriberIds().map(subscriberId => {
                    let subscriber = _commonState.get(subscriberId);
                    if (subscriber.type === _commonState.types.user) {
                        return {
                            avatar: subscriber.avatar,
                            isUser: true,
                            isUserGroup: false,
                            sortName: subscriber.name,
                            toolTipText: subscriber.name,
                            userId: subscriber.id,
                        };
                    }
                    if (subscriber.type === _commonState.types.userGroup) {
                        const groupName = subscriber.name;
                        const groupMembers = subscriber.members()
                            .filter(member => _commonState.get(member).isSelectable())
                            .map(member => {
                                return {
                                    name: _commonState.get(member).name,
                                    id: member
                                };
                            });

                        sorter.sort(groupMembers, "name", true);

                        const groupMembersLastIndex = groupMembers.length - 1;
                        const toolTipText = ko.observable([
                            {
                                style: "bold",
                                text: groupName,
                                carriageReturn: true
                            },
                            ...groupMembers.map((member, index) => {
                                const isLastGroupMember = index === groupMembersLastIndex;
                                return {
                                    style: "standard",
                                    text: ko.pureComputed(() => isLastGroupMember ?
                                        member.name() :
                                        member.name() + ","
                                    ),
                                    carriageReturn: true
                                };
                            })
                        ]);

                        return {
                            avatar: subscriber.avatars,
                            isUser: false,
                            isUserGroup: true,
                            sortName: groupName,
                            toolTipText: toolTipText,
                            userId: subscriber.id,
                        };
                    }
                });
                sorter.sort(subscribers, "sortName", true);
                return subscribers;
            });

            self.compositionComplete = () => {
                self.isCompositionComplete(true);
            };

            self.activate = (settings) => {
                _settings = settings;

                _initialize();
            };

            const _initialize = () => {
                if (_settings.callDetails) {
                    if (ko.isObservable(_settings.callDetails)) {
                        self.callDetails = _settings.callDetails;
                    } else {
                        self.callDetails(_settings.callDetails);
                    }
                } else {
                    throw new Error("callDetails is required");
                }

                if (_settings.showCallMedia !== undefined) {
                    self.showCallMedia(_settings.showCallMedia);
                }

                if (_settings.showFormSubmission !== undefined) {
                    self.showFormSubmission(_settings.showFormSubmission);
                }

                if (_settings.isCollapsible !== undefined) {
                    self.isCollapsible(_settings.isCollapsible);
                }
            };
        };
    });
